import { IContext } from "./IContext";
import { ISharedVideoContext } from "./SharedVideoContext";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { LogGroup ,MyPIXIContainer } from ".././MyHelpers";
import { ResourceManager } from "../ResourceManager/ResourceManager";
import { ITimingContext } from "./TimingContext";
import { SharedVideoContainer , SharedVideoContext } from "./SharedVideoContext";
import { TimingContext } from "./TimingContext";
import { ISharedTranstionContext, SharedTransitionContainer, SharedTransitionContext } from "./SharedTransitionContext";
export interface ISystemContext extends IContext
{
    TimingContext(): ITimingContext;
    SharedVideoContext(): ISharedVideoContext;
    SharedVideoContainer(): SharedVideoContainer;

    SharedTransitionContext(): ISharedTranstionContext;

    CreateSubContext(name: string | string[]): ISystemContext;
}



export class SystemContext implements ISystemContext
{
    public static readonly InheritScreenNumber: number = -1
    protected parentResid: ResourceIdentifier = null;
    protected resid: ResourceIdentifier = null;

    protected parentLogGroup: LogGroup = null;
    protected logGroup: LogGroup = null; //new LogGroup("SystemContext");

    protected timingContext: ITimingContext = null;
    protected sharedVideoContext: ISharedVideoContext = null;
    protected sharedTransitionContext: ISharedTranstionContext = null;

    protected resourceManager: ResourceManager = null;
    protected sharedVideoContainer: SharedVideoContainer = null;
    protected sharedTransitionContainer: SharedTransitionContainer = null;

    protected enabled: boolean = false;
    protected contexts: IContext[] = [];

    public constructor(resid: ResourceIdentifier, logGroup: LogGroup, resourceManager: ResourceManager, sharedVideoContainer: SharedVideoContainer , sharedTransitionContainer: SharedTransitionContainer)
    {
        this.parentResid = resid;
        this.parentLogGroup = logGroup;

        this.resid = resid.Add("SystemContext");
        this.logGroup = logGroup.Add("SystemContext");

        this.sharedVideoContainer = sharedVideoContainer;
        this.sharedTransitionContainer = sharedTransitionContainer


        this.timingContext = new TimingContext(resid.Add("Timing"), logGroup.Add("Timing"));
        this.contexts.push(this.timingContext);

        this.sharedVideoContext = new SharedVideoContext(resid.Add("SharedVideo"), logGroup.Add("SharedVideo"), sharedVideoContainer);
        this.contexts.push(this.sharedVideoContext);

        this.sharedTransitionContext = new SharedTransitionContext(resid.Add("SharedTransition"), logGroup.Add("SharedTransition"), sharedTransitionContainer);
        this.contexts.push(this.sharedTransitionContext);


    }



    public TimingContext(): ITimingContext
    {
        return this.timingContext;
    }

    public SharedVideoContext(): ISharedVideoContext
    {
        return this.sharedVideoContext;
    }

    public SharedVideoContainer(): SharedVideoContainer
    {
        return this.sharedVideoContainer;
    }

    public SharedTransitionContext(): ISharedTranstionContext
    {
        return this.sharedTransitionContext;
    }

    protected subcontexts: SystemContext[] = [];
    public CreateSubContext(name: string | string[]): ISystemContext
    {
        let context = new SystemContext(this.parentResid.Add(name), this.parentLogGroup.Add(name), this.resourceManager, this.sharedVideoContainer, this.sharedTransitionContainer);

        this.subcontexts.push(context);
        return context;
    }

    public Name(): string
    {
        return this.resid.ID();
    }


    public Enable(): void
    {
        if (!this.enabled)
        {
            this.enabled = true;
        }

        for (let i = 0; i < this.contexts.length; i++)
        {
            this.contexts[i].Enable();
        }

        for (let i = 0; i < this.subcontexts.length; i++)
        {
            this.subcontexts[i].Enable();
        }
    }

    public Disable(): void
    {
        if (this.enabled)
        {
            this.enabled = false;
        }

        for (let i = 0; i < this.contexts.length; i++)
        {
            this.contexts[i].Disable();
        }

        for (let i = 0; i < this.subcontexts.length; i++)
        {
            this.subcontexts[i].Disable();
        }
    }

    public Running(): boolean
    {
        return this.enabled;
    }
}